import React from 'react';

const COUNTRY_FLAGS = { USA: '🇺🇸', US: '🇺🇸', UAE: '🇦🇪', AE: '🇦🇪' };

const PALETTE = [
  { bg: '#eff6ff', fg: '#2563eb' },
  { bg: '#ecfdf5', fg: '#059669' },
  { bg: '#fffbeb', fg: '#d97706' },
  { bg: '#faf5ff', fg: '#9333ea' },
  { bg: '#fdf2f8', fg: '#db2777' },
  { bg: '#f0fdfa', fg: '#0d9488' },
];

// Each city gets a deterministic "stamp" look: color, corner shape, slight tilt
const SHAPES = ['18px', '18px 4px 18px 4px', '4px 18px 4px 18px', '9999px'];
const TILTS = ['-2deg', '1.5deg', '-1deg', '2deg'];

const hashCity = (s) => {
  let h = 0;
  for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) >>> 0;
  return h;
};

/**
 * Experience Passport — flat "stamps" for every destination the customer
 * has completed an experience in. Earned, not assumed.
 */
export const ExperiencePassport = ({ stamps = [] }) => (
  <div className="mt-2 bg-gray-50 rounded-2xl px-3 py-4" data-testid="experience-passport">
    <p className="text-xs font-semibold text-gray-400 uppercase tracking-wide text-center mb-3">Experience Passport</p>

    {stamps.length === 0 ? (
      <p className="text-xs text-gray-400 text-center leading-relaxed px-2">
        Your passport is waiting for its first stamp — complete an experience and the destination lands here.
      </p>
    ) : (
      <div className="flex flex-wrap justify-center gap-2">
        {stamps.map((s) => {
          const h = hashCity(s.city || '?');
          const pal = PALETTE[h % PALETTE.length];
          return (
            <div
              key={`${s.city}-${s.country}`}
              data-testid={`passport-stamp-${s.city}`}
              className="flex flex-col items-center px-3 py-2 animate-in zoom-in duration-300"
              style={{
                backgroundColor: pal.bg,
                borderRadius: SHAPES[h % SHAPES.length],
                transform: `rotate(${TILTS[h % TILTS.length]})`,
              }}
              title={`${s.count} experience${s.count === 1 ? '' : 's'} in ${s.city}`}
            >
              <span className="text-lg leading-none">{COUNTRY_FLAGS[(s.country || '').toUpperCase()] || '🌍'}</span>
              <span className="text-[11px] font-bold mt-1" style={{ color: pal.fg }}>{s.city}</span>
              <span className="text-[9px] font-medium" style={{ color: pal.fg, opacity: 0.7 }}>
                {s.count > 1 ? `×${s.count}` : 'stamped'}
              </span>
            </div>
          );
        })}
      </div>
    )}
  </div>
);

export default ExperiencePassport;
